import React, { useEffect, useState, useRef } from 'react';
import swal from 'sweetalert2';
import ImageCropper from '../components/global/imageCropper';
import * as helper from '../components/global/helper';

const imgUrl = 'https://metromatrix.s3.ap-south-1.amazonaws.com/Public/MetroMatrix/Content/';

import { getTPAList, postTPA } from './api/tpaAPI';
import { uploadPublicFile } from './api/fileAPI'
import EmptyView from './global/emptyView';

const TPA = (props) => {

    const [tpaList,             setTPAList]              = useState([]);
    const [filteredTPAList,     setFilteredTPAList]     = useState([]);

    const [tpa,                 setTPA]                 = useState({ID: 0, Active: 'Y'});
    const [showPassword,        setShowPassword]        = useState(false);
    const [validated,           setValidated]           = useState(false);

    const [selectedImage,       setSelectedImage]       = useState(null);
    const [selectedImageType,   setSelectedImageType]   = useState(null);

    const [croppedLogo,         setCroppedLogo]         = useState(null);   
    const logoInputRef          = useRef(null);

    const [croppedStamp,        setCroppedStamp]        = useState(null);   
    const stampInputRef         = useRef(null);

    useEffect(() => {
        fetchTPAList();
        const modalElement = document.getElementById('addModal');
        const handleModalHide = () => resetData();
        modalElement.addEventListener('hidden.bs.modal', handleModalHide);
        return () => {
            modalElement.removeEventListener('hidden.bs.modal', handleModalHide);
        };
    }, [])

    const fetchTPAList = async() => {
        try {
            swal.fire({
                titleText           : 'Loading',
                text                : 'Please Wait...',
                showConfirmButton   : false,
                allowOutsideClick   : false,
                didOpen: () => {
                    swal.showLoading();
                }
            });
            const { TPAList } = await getTPAList();
            setTPAList(TPAList);
            setFilteredTPAList(TPAList);
            swal.close();
        } catch (err) {
            swal.close();
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }

    const postTPAData = async(e)=> {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {     
            e.stopPropagation();
            setValidated(true);
        }else{
            try {
                swal.fire({
                    titleText           : 'Loading',
                    text                : 'Please Wait...',
                    showConfirmButton   : false,
                    allowOutsideClick   : false,
                    didOpen: () => {
                        swal.showLoading();
                    }
                });

                let logo = tpa.Logo ? tpa.Logo : '';
                if(croppedLogo){
                    const res = await uploadPublicFile(croppedLogo, 'Content');
                    logo = res.FileName;
                }

                let stamp = tpa.Stamp ? tpa.Stamp : '';
                if(croppedStamp){
                    const res = await uploadPublicFile(croppedStamp, 'Content');
                    stamp = res.FileName;
                }

                if (stamp == '') {
                    swal.close();
                    swal.fire({
                        icon              : "error",
                        titleText         : "Error!",
                        text              : "Upload Stamp",
                        didOpen: () => {
                            swal.hideLoading();
                        }
                      })
                      return; 
                }

                await postTPA(
                    {
                        ...tpa,
                        Logo: logo,
                        Stamp: stamp
                    }
                );
                await fetchTPAList();
                document.querySelector('#addModal .btn-close').click();

                swal.close();

                if (tpa.ID) {
                    swal.fire({
                        icon: 'success',
                        title: '<small>TPA updated successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }else {
                    swal.fire({
                        icon: 'success',
                        title: '<small>TPA added successfully!</small>',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
          
            } catch (err) {
                swal.close();
                swal.fire({
                    icon              : "error",
                    titleText         : "Error!",
                    text              : err.message
                  })
                return;  
            }
        }    
    }

    const onTPASearch = (searchTerm) => {
        if(!searchTerm || searchTerm === '') return setFilteredTPAList(tpaList);

        //filter as per searched
        const filtered = tpaList.filter(m => {
            let matchString = `${m.Name} ${m?.Email} ${m.Contact} ${m.ContactPersonName} ${m.ContactPersonEmail} ${m.ContactPersonPhone}`;
            let matchFound  = 0;
            var searchArr   = searchTerm.split(' ');
            
            searchArr.forEach(t => matchFound += matchString.toLowerCase().includes(t.toLowerCase()) ? 1 : 0);

            return matchFound === searchArr.length;
        });
        
        setFilteredTPAList(filtered);
    };

    const handleData = (key, value)=>{
        setTPA((d)=> { return {...d, [key] : value} });
    };

    const resetData = () => {
        setTPA({ID: 0, Active: 'Y'});
        setShowPassword(false);
        setCroppedLogo(null);
        setCroppedStamp(null);
        setValidated(false);
        logoInputRef.current.value = null;
        stampInputRef.current.value = null;
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleFileChange = (e, type) => {
        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result);
            setSelectedImageType(type);
          };
          reader.readAsDataURL(file);
        }
    };

    const handleCropComplete = (croppedImg, type) => {
        if (type == 'Stamp') {
            setCroppedStamp(croppedImg);
            stampInputRef.current.value = null; 
        }else {
            setCroppedLogo(croppedImg);
            logoInputRef.current.value = null; 
        }
        setSelectedImage(null);
        setSelectedImageType(null)
    };

    const handleCropCancel = () => {
        setSelectedImage(null);
        setSelectedImageType(null)
    };

    return ( 
        <>

            <div className="navbar navbar-expand-lg fixed-top margin-t58" style={{backgroundColor: '#fff', zIndex: '1'}}>
                <div className="container d-block padding-t10" style={{height: '60px'}}>
                    <div className='row mb-4'>
                        <div className='col-12'>
                            <div className='input-group'>
                                <span className='input-group-text fs-16'><i className="bi bi-search"></i></span>
                                <input 
                                    className="form-control fs-16" 
                                    type="search" 
                                    placeholder="Search"
                                    onChange={({target}) => onTPASearch(target.value)}
                                />
                            </div>
                        </div>      
                    </div>
                </div>
            </div>

            <div className='container margin-t150'>  
                <div className='row'>
                    {filteredTPAList.length > 0 ? filteredTPAList.map((m, i) => (
                        <div className='col-lg-6' key={m.ID}>  
                            <div className="card border-primary mb-4" data-bs-toggle="modal" data-bs-target="#addModal" onClick={() => setTPA(m)}>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <div className='flex-shrink-0'>
                                        {m.Logo && m.Logo != '' ?
                                            <img src={`${imgUrl}${m.Logo}`} alt="image" className="rounded-circle" width="70" height="70"/> :
                                            <div className="initial-circle-tpa me-2">
                                                {m.Name[0]}
                                            </div>
                                        }                                           
                                    </div>
                                    <div className="ms-3 flex-grow-1">
                                        <h6 className="card-title mb-1">{m.Name}</h6>
                                        <span className='card-text fs-16'>
                                            <span><i className="bi bi-telephone text-primary"></i> {m.Contact}</span><br/>
                                            <span><i className="bi bi-envelope text-primary"></i> {m.Email}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="position-relative my-2">
                                    <hr className='my-0'/>
                                    <span className="position-absolute top-50 start-50 translate-middle bg-white px-2 text-muted fs-14">Contact Person</span>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center ms-2">
                                    <div className='flex-shrink-0'>
                                        <div className="initial-circle-2x me-2">
                                            {m.ContactPersonName[0]}
                                        </div>
                                    </div>
                                    <div className="ms-2 flex-grow-1" style={{ lineHeight: '1' }}>
                                        <h6 className="card-title fs-14 mb-1">{m.ContactPersonName}</h6>
                                        <span className='card-text fs-13'>
                                            <span><i className="bi bi-telephone text-primary"></i> {m.ContactPersonPhone}</span><br/>
                                            <span><i className="bi bi-envelope text-primary"></i> {m.ContactPersonEmail}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <EmptyView message={'No TPA!'}/>
                    )}                  
                </div>
            </div>

            <div id='addModal' className="modal modal-lg fade" tabIndex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id="modalLabel">{(!tpa.ID || tpa.ID == 0) ? 'Add' : 'Update'} TPA</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form id='tpaForm' className={`row mt-3 needs-validation ${validated ? "was-validated" : ""}`} noValidate onSubmit={postTPAData}>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Name', target.value)}
                                                value={ tpa.Name || '' }
                                                id="txtName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='Name' 
                                                required
                                            />
                                            <label htmlFor="txtName">Name</label>
                                            <div className="invalid-feedback">Please enter name</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('Email', helper.email(target.value))}
                                                value={ tpa.Email || '' }
                                                id="txtEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='Email'
                                                required 
                                            />
                                            <label htmlFor="txtEmail">Email</label>
                                            <div className="invalid-feedback">Please enter email</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('Contact', helper.contact(target.value))}
                                                value={ tpa.Contact || '' }
                                                id="txtContactNo" 
                                                type="text"
                                                className="form-control" 
                                                placeholder='Contact No' 
                                                required
                                            />
                                            <label htmlFor="txtContactNo">Contact No</label>
                                            <div className="invalid-feedback">Please enter contact no.</div>
                                        </div>
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('Password', target.value)}
                                                value={ tpa.Password || '' }
                                                id="txtPassword" 
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control" 
                                                placeholder='Password' 
                                                required
                                            />
                                            <label htmlFor="txtPassword">Password</label>
                                            <div className="invalid-feedback">Please enter password</div>
                                            <span
                                                className='password-toggle'
                                                onClick={togglePasswordVisibility}>
                                                {showPassword ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                            </span>
                                        </div>
                                    </div>  
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('ContactPersonName', helper.camelCase(target.value))}
                                                value={ tpa.ContactPersonName || '' }
                                                id="txtContactPersonName" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='Contact Person Name' 
                                                required
                                            />
                                            <label htmlFor="txtContactPersonName">Contact Person Name</label>
                                            <div className="invalid-feedback">Please enter contact person name</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input
                                                onChange={({ target }) => handleData('ContactPersonEmail', helper.email(target.value))}
                                                value={ tpa.ContactPersonEmail || '' }
                                                id="txtContactPersonEmail" 
                                                type="email" 
                                                className="form-control" 
                                                placeholder='Contact Person Email'
                                                required 
                                            />
                                            <label htmlFor="txtContactPersonEmail">Contact Person Email</label>
                                            <div className="invalid-feedback">Please enter contact person email</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('ContactPersonPhone', helper.contact(target.value))}
                                                value={ tpa.ContactPersonPhone || '' }
                                                id="txtContactPersonPhone" 
                                                type="text"
                                                className="form-control" 
                                                placeholder='Contact Person Phone' 
                                                required
                                            />
                                            <label htmlFor="txtContactPersonPhone">Contact Person Phone No</label>
                                            <div className="invalid-feedback">Please enter contact person phone no.</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <div className="form-floating">
                                            <input 
                                                onChange={({ target }) => handleData('MspCode', helper.capitalize(target.value))}
                                                value={ tpa.MspCode || '' }
                                                id="txtMspCode" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder='MSP Code' 
                                                required
                                            />
                                            <label htmlFor="txtMspCode">MSP Code</label>
                                            <div className="invalid-feedback">Please enter MSP code</div>
                                        </div>
                                    </div>
                                    <div className='col-12 mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <input 
                                                ref={logoInputRef}
                                                className="form-control d-none" 
                                                type="file" 
                                                id="fileLogo"
                                                accept=".png, .jpeg, .jpg"
                                                onChange={(e) => handleFileChange(e, 'Logo')}
                                            />
                                            <label htmlFor="fileLogo" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                <span>{(!!croppedLogo || tpa.Logo)  ? "Change Logo" : "Upload Logo"}</span>
                                                <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                    <i className="bi bi-upload"></i>
                                                </span>
                                            </label>
                                            {(!!croppedLogo || tpa.Logo) && (
                                                <>
                                                    <a type="button" href={croppedLogo ? URL.createObjectURL(croppedLogo) : `${imgUrl}${tpa.Logo}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                    <button type="button" onClick={() => {setCroppedLogo(null); handleData('Logo', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                </>
                                            )}
                                        </div>
                                    </div> 
                                    <div className='col-12 mb-3'>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <input 
                                                ref={stampInputRef}
                                                className="form-control d-none" 
                                                type="file" 
                                                id="fileStamp"
                                                accept=".png, .jpeg, .jpg"
                                                onChange={(e) => handleFileChange(e, 'Stamp')}
                                            />
                                            <label htmlFor="fileStamp" className="form-control d-flex justify-content-between align-items-center file-uploader">
                                                <span>{(!!croppedStamp || tpa.Stamp)  ? "Change Stamp" : "Upload Stamp"}</span>
                                                <span className="upload-icon" style={{ marginLeft: 'auto' }}>
                                                    <i className="bi bi-upload"></i>
                                                </span>
                                            </label>
                                            {(!!croppedStamp || tpa.Stamp) && (
                                                <>
                                                    <a type="button" href={croppedStamp ? URL.createObjectURL(croppedStamp) : `${imgUrl}${tpa.Stamp}`} target='_blank' className="btn btn-primary ms-2">View</a>
                                                    <button type="button" onClick={() => {setCroppedStamp(null); handleData('Stamp', '')}} className="btn btn-secondary ms-2">Remove</button>
                                                </>
                                            )}
                                        </div>
                                    </div>    
                                    <div className='col-md-12 mb-3'>
                                        <div className="form-check form-switch d-flex justify-content-center align-items-center">
                                            <label className="me-5 pe-2 mb-0">Active</label>
                                            <input 
                                                className="form-check-input switch me-5" 
                                                type="checkbox" 
                                                defaultChecked={tpa.Active == 'N' ? '' : 'checked'}
                                                onChange={(event) => handleData('Active', event.target.checked ? 'Y' : 'N')} 
                                            />
                                        </div>
                                    </div>
                                                                  
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" form='tpaForm' className="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </div>

            {selectedImage && (
                <div className="cropper-overlay">
                    <ImageCropper 
                        image={selectedImage}
                        type={selectedImageType}
                        dimension={{width: 250, height: 250}}
                        onCropComplete={handleCropComplete}
                        onCropCancel={handleCropCancel}
                    />
                </div>
            )}

        </>
    )

}

export default TPA;